import { Heading } from "@planningcenter/doxy-web"
import { EventLink } from "./EventListing"
import { bool, string, oneOf, shape } from "prop-types"
import { Card } from "../../shared/components"

const GalleryEvent = ({ layout, event }) => {
  const {
    eventDay,
    imageUrl,
    fallbackImageUrl,
    name,
    formattedEndsAt,
    formattedStartsAt,
    multiDayEvent,
    recurring,
    schedule,
    campus,
    featured,
    registrationUrl,
    showPagePath,
  } = event

  const canRegister = registrationUrl?.canRegister

  return (
    <Card
      layout={layout}
      link={{ as: EventLink, eventDay, showPagePath }}
      poster={imageUrl || fallbackImageUrl}
      heading={name}
      description={
        <>
          <>{formattedStartsAt}</>
          {multiDayEvent && formattedEndsAt !== formattedStartsAt && (
            <> - {formattedEndsAt}</>
          )}
          {recurring && <span className="c-tint2"> | Recurring</span>}
          {schedule}
        </>
      }
      footnote={
        campus && <Heading color="tint3" level={2} size={6} text={campus} />
      }
      badges={[
        featured && { label: "Featured", theme: "featured" },
        canRegister && { label: "Signups available" },
      ]}
    />
  )
}
GalleryEvent.propTypes = {
  event: shape({
    eventDay: string.isRequired,
    imageUrl: string,
    fallbackImageUrl: string,
    name: string.isRequired,
    formattedEndsAt: string.isRequired,
    formattedStartsAt: string.isRequired,
    multiDayEvent: bool.isRequired,
    recurring: bool.isRequired,
    schedule: string,
    campus: string.isRequired,
    featured: bool.isRequired,
    registrationUrl: string,
  }),
  layout: oneOf(["row", "column"]),
}

export default GalleryEvent
